import Error from '@/views/Error/404' // 404页面
import Index from '@/views/ProjectIndex/indexDefault/index' // 项目端首页
import Task from '@/views/Task/TaskDefault/index' // 任务
import Messages from '@/views/Message/MessageDefault/index' // 消息
import SelectMenu from '@/views/SelectMenu/selectMenuDefault/index' // 选项选择页面
import ProjectExtend from '@/views/ProjectExtend/projectExtendDefault/index' // 扩展信息
import PersonnelStatistics from '@/views/PersonnelStatistics/personnelStatisticsDefault/personnelStatistics.vue' // 人员统计
import Person from '@/views/Person/personCd/index' // 人员管理
import Attendance from '@/views/Attendance/attendanceDefault/index' // 考勤管理
import Team from '@/views/Team/teamDefault/index' // 班组管理
import PersonnelAudit from '@/views/PersonnelAudit/personnelAuditCd/index' // 人员审核
import Abnormal from '@/views/Abnormal/abnormalDefault/index' // 异常人员
import BlackMenu from '@/views/PerBlackMenu/perBlackMenuDefault/index' // 人员黑名单
import Behavior from '@/views/Behavior/BehaviorCq2/index' // 人员诚信行为
import MonitorLive from '@/views/MonitorLive/MonitorLiveDefault/index' // 直播画面
import MonitorScreen from '@/views/MonitorScreen/MonitorScreenDefault/index' // 监控画面
import Access from '@/views/Access/accessDefault/index' // 门禁设备
import Tower from '@/views/Tower/towerDefault/index' // 塔机黑匣子
import Environment from '@/views/Environmental/environmentDefault/index' // 环境监测
import Elevator from '@/views/Elevator/elevatorDefault/index' // 施工升降机
import LED from '@/views/LED/ledDefault/index' // LED控制主板
import Helmet from '@/views/Helmet/helmetDefault/index.vue' // AI监测
import Unloading from '@/views/Unloading/unloadingDefault/index.vue' // 卸料平台
import Quality from '@/views/Quality/qualityDefault/index' // 质量统计
import QualityInspection from '@/views/QualityInspection/qualityInspectionDefault/index' // 质量巡检记录
import QualityInspectionSet from '@/views/QualityInspectionSet/qualityInspectionSetDefault/index' // 质量巡检设置
import QualityCheckPerson from '@/views/QualityCheckPerson/qualityCheckPersonDefault/index.vue' // 质量巡检人管理
import Safety from '@/views/Safety/safetyDefault/index' // 安全统计
import SafetyInspection from '@/views/SafetyInspection/safetyInspectionDefault/index' // 安全巡检记录
import SafetyInspectionSet from '@/views/SafetyInspectionSet/safeInspectionSetDefault/index' // 安全巡检设置
import SafetyCheckPerson from '@/views/SafetyCheckPerson/safetyCheckPersonDefault/index.vue' // 安全巡检人管理
import SpecialTrain from '@/views/SpecialTrain/specialTrainDefault/index.vue' // 专项培训
import SpecialExam from '@/views/SpecialExam/specialExamDefault/index.vue' // 专项考试
import SpecialExamTest from '@/views/SpecialExamTest/specialExamTestDefault/index.vue' // 新增专项考试试卷
import TotalTrain from '@/views/TotalTrain/totalTrainDefault/index.vue' // 培训统计
import TotalExam from '@/views/TotalExam/totalExamDefault/index.vue' // 考试统计
import TestManage from '@/views/TestManage/testManageDefault/index.vue' // 题库管理
import DigitalSite from '@/views/DigitalSite/index.vue' // 数字化管理
import SolidWaste from '@/views/SolidWaste/index.vue' // 固废管理
import BimModel from '@/views/BimModel/index.vue' // BIM模型
import Broadcast from '@/views/Broadcast/broadcastDefault/indexV2' // 云广播
import AlarmPanel from '@/views/AlarmPanel/alarmPanelDefault/index' // 混合报警面板
/* 默认区域路由 */
const routerCd = [{
    path: '/select',
    component: SelectMenu
}, {
    path: '/',
    redirect: '/personnelStatistics', // 默认跳转项目信息页面
    name: 'selectMenu',
    component: SelectMenu,
    children: [{
            path: '/alarmPanel', // 混合报警面板
            component: AlarmPanel
        }, {
            path: '/behavior', // 人员诚信行为
            component: Behavior,
        }, {
            path: '/broadcast', // 云广播
            component: Broadcast,
        }, {
            path: '/projectExtend', // 扩展信息
            component: ProjectExtend,
        }, {
            path: 'personnelStatistics', // 人员统计
            component: PersonnelStatistics
        }, {
            path: '/person', // 人员管理
            component: Person,
        }, {
            path: '/attendance', // 考勤管理
            component: Attendance,
        }, {
            path: '/team', // 班组管理
            component: Team,
        },
        {
            path: '/personnelAudit', // 人员审核
            component: PersonnelAudit,
        }, {
            path: '/abnormal', // 异常人员
            component: Abnormal,
        }, {
            path: '/blackMenu', // 人员黑名单
            component: BlackMenu,
        }, {
            path: '/monitorlive', // 直播画面
            component: MonitorLive
        }, {
            path: '/monitorscreen', // 监控画面
            component: MonitorScreen
        }, {
            path: '/access', // 门禁设备
            component: Access,
        }, {
            path: '/tower', // 塔机黑匣子
            component: Tower,
        }, {
            path: '/environment', // 环境监测
            component: Environment,
        }, {
            path: '/elevator', // 施工升降机
            component: Elevator,
        }, {
            path: '/led', // LED控制主板
            component: LED,
        }, {
            path: '/helmet', // AI监测
            component: Helmet
        }, {
            path: '/unloading', // 卸料平台
            component: Unloading
        }, {
            path: '/quality', //质量统计
            component: Quality,
        }, {
            path: '/qualityInspection', // 质量巡检记录
            component: QualityInspection,
        }, {
            path: '/qualityInspectionSet', // 质量巡检设置
            component: QualityInspectionSet,
        }, {
            path: '/qualityCheckPerson', // 质量巡检人管理
            component: QualityCheckPerson
        }, {
            path: '/safety', // 安全统计
            component: Safety,
        }, {
            path: '/safetyInspection', // 安全巡检记录
            component: SafetyInspection,
        }, {
            path: '/safetyInspectionSet', // 安全巡检设置
            component: SafetyInspectionSet
        }, {
            path: '/safetyCheckPerson', // 安全巡检人管理
            component: SafetyCheckPerson
        }, {
            path: '/specialTrain', // 专项培训
            component: SpecialTrain
        }, {
            path: '/specialExam', // 专项考试
            component: SpecialExam
        }, {
            path: '/specialExamTest/:id', // 新增专项考试试卷
            component: SpecialExamTest
        }, {
            path: '/totalTrain', // 培训统计
            component: TotalTrain,
        }, {
            path: '/totalExam', // 考试统计
            component: TotalExam,
        }, {
        }, {
            path: 'testManage', // 题库管理
            component: TestManage
        }, {
            path: '/digitalSite', // 数字化管理
            component: DigitalSite
        }, {
            path: '/solidWaste', // 固废管理
            component: SolidWaste
        }, {
            path: '/bimModel', // BIM模型
            component: BimModel
        }, {
            path: '/task', // 任务
            component: Task
        }, {
            path: '/message', // 消息
            component: Messages
        }
    ]
}, {
    path: '/index',
    name: 'index',
    component: Index,
}, {
    path: '*',
    name: '404',
    component: Error,
    hidden: true
}]

export default routerCd



// WEBPACK FOOTER //
// ./src/router/routerCd.js